import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { db, storage } from "../firebase";
import { uuidv4 } from '@firebase/util';
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { setLocalData } from "../utils/functions";
import heic2any from "heic2any";

/**
* **이미지 업로드 함수**
*
* @param {string} file - 이미지의 dataUrl
*/
export const uploadProfileImageAndGetUrl = async (file: File | Blob) => {
    const imageRef = ref(storage, "profiles/" + uuidv4())
    try {
        // 'file' comes from the Blob or File API
        const snapshot = await uploadBytes(imageRef, file);
        const result = await getDownloadURL(snapshot.ref);

        return result
    } catch (err) {
        console.error(err);
        throw new Error('프로필 이미지 업로드 하는 데에서 문제 발생')
    }
}

/**
 * 사용자(User)의 `stamps` 배열에 `stampId`를 추가하는 함수
 * @param userId 
 * @param stampId 
 */
export const addProfileImageToUser = async (userId: string | undefined, profileImage: File | Blob | any) => {
    try {
        if (!userId) {
            throw new Error("current user id is undefined")
        }
        
        // heic 파일인 경우 jpeg로 변환
        let fileBlob = profileImage;
        const MAX_MB = 10;
    
        if (!fileBlob) {
          return;
        }
        
        if (/\.(heic)$/i.test(fileBlob.name)) {
          fileBlob = await heic2any({ blob: fileBlob, toType: 'image/jpeg' });
        }
    
        // const reader = new FileReader();
        // reader.readAsDataURL(fileBlob);
        // reader.onload = () => {
        //   setImageSrc(reader.result);
        //   onChange(reader.result);
        // };

        // UPLOAD
        // 사용자(User) 문서를 참조
        const userRef = collection(db, 'user');
        const userDocRef = doc(userRef, userId);

        const imageUrl = await uploadProfileImageAndGetUrl(fileBlob);

        if (!imageUrl) {
            console.error("프로필 이미지 업로드 실패")
            return;
        }
        setLocalData("profile", imageUrl);
        // 업데이트된 `stamps` 배열을 사용자(User) 문서에 저장
        await updateDoc(userDocRef, { profileImage: imageUrl });

        return imageUrl; // 성공적으로 업데이트되었음을 나타내는 값 반환
    } catch (error) {
        console.error('Error adding stampId to user:', error);
        throw error;
    }
}

/**
 * 유저 데이터 불러오는 함수
 * @param userId 
 * @returns 
 */
export const getUserInfo = async(userId:string) => {
    // 사용자(User) 문서를 참조
    const userRef = collection(db, 'user');
    const userDocRef = doc(userRef, userId);

    const userInfo = await getDoc(userDocRef);

    if(!userInfo?.data()){
        console.error("유저 정보를 불러오지 못 함.");
        return null;
    }

    return userInfo?.data();
}